import { z } from 'zod/v4';

import { ZOD_ERROR } from '../models/constants';
import { assetPasswordResetResultSchema } from './asset-password-reset-result.schema';
import { BaseMessage, baseMessageSchema } from './base-message.schema';

const assetPasswordResetOperationSchema = z.object({
  id: z.string(),
  type: z.string(),
  result: assetPasswordResetResultSchema,
});

export const assetPasswordResetOperationEventSchema =
  baseMessageSchema.transform((data) => {
    const message = JSON.parse(data.message) as BaseMessage;
    const { success, data: result } =
      assetPasswordResetOperationSchema.safeParse(message);

    if (success) {
      return result;
    }

    return {
      type: '',
      id: '',
      result: {
        errorCode: ZOD_ERROR,
        totalPasswordResets: 0,
        totalPasswordResetFailures: 0,
      },
    };
  });
